import TagSelectBloc from '../../../shared/tagSelectBloc/TagSelectBloc.vue'

export default {
  name: 'UserSkills',
  components: { TagSelectBloc },
  props: {
    skills: {
      type: Array,
      default: () => []
    },
    editable: Boolean
  },
  computed: {
    allSkills() {
      return this.$store.getters.skills
    }
  },
  methods: {
    async saveSkill(skill) {
      if (!skill.id) {
        skill = await this.$store.dispatch('createSkill', skill.name)
      }
      return this.$store.dispatch('addSkill', skill)
    },
    removeSkill(skill) {
      this.$store.dispatch('removeSkill', skill.id)
    }
  }
}
